import { createSvgIcon } from "@mui/material";

const InsertRowTop = createSvgIcon(
  // From https://remixicon.com/ (https://github.com/Remix-Design/RemixIcon)
  <path d="M20 13C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V14C3 13.4477 3.44772 13 4 13H20ZM19 15H5V19H19V15ZM12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1ZM13 3H11V4.999L9 5V7L11 6.999V9H13V6.999L15 7V5L13 4.999V3Z"></path>,
  "InsertRowTop"
);

export default InsertRowTop;
